import generalSection from "../_section/section.class";
import {adminHTBSchemeFormsUpload, userHTBSchemeFormsUpload} from "./upload";
import problem from "../_section/section-problem.class";
import ApplicationForm from "./ApplicationForm";
export class userHTBSchemeFormsSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userHTBSchemeFormsUpload);
        // Add missing date error

    }
}

export class adminHTBSchemeFormsSection extends userHTBSchemeFormsSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminHTBSchemeFormsUpload);
        // this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm;
        this.activeUpload = this.activeUploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.sortByDateProp('expiryDate');
        this.setProblems( this.getProblems());
    }
    getProblems (){
        const problems =  this.problemsList.singleUploadUserProblems();
        if (!problems.length){
            // Amount Mismatch
            const applicationAmount = this.mortgage.requirement.helpToBuySchemeAmount
            if (this.amount && applicationAmount && this.amount !== applicationAmount) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Data Mismatch',
                    reason: 'Application amount doesnt match the upload',
                    uploadIDs: [this.activeUpload.id],
                    message: `${this.amount} does not match the application amount (${applicationAmount})`,
                }))
            }
        }
        return problems;
    }

    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }
    get accessCode() {
        if (this.activeUpload && this.activeUpload.values.accessCode) {
            return this.activeUpload.values.accessCode;
        }
        return null;
    }
    get applicationCode() {
        if (this.activeUpload && this.activeUpload.values.applicationCode) {
            return this.activeUpload.values.applicationCode;
        }
        return null;
    }
    get amount() {
        if (this.activeUpload && this.activeUpload.values.amount) {
            return this.activeUpload.values.amount;
        }
        return null;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'Dated',
                    value: this.activeUpload?.values?.documentDate?.format('D MMM YYYY') || 'Not Provided'
                },
                {
                    name: 'Access Code',
                    value: this.activeUpload?.values?.accessCode || 'Not Provided'
                },
                {
                    name: 'Application Code',
                    value: this.activeUpload?.values?.applicationCode || 'Not Provided'
                },
                {
                    name: 'Amount',
                    value: this.activeUpload?.values?.amount ? `£${this.activeUpload.values.amount.toLocaleString()}` : 'Not Provided'
                },
                {
                    name: 'Expiry Date',
                    value: this.activeUpload?.values?.expiryDate?.format('D MMM YYYY') || 'Not Provided'
                }
            ]
            }
        ]
    }
}